
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
type PhoneDialpadType = {
    onPress: (s: string) => void;
};

type PhoneButtonProps = {
    digit: string,
    letters: string,
    onPress: (s: string) => void
}

function PhoneButton ({ digit, letters, onPress }: PhoneButtonProps) {
    return (
        <Button
            sx={{width: { xs: "65px", sm: "65px", md: "80px"}} }
            variant="outlined" onClick={() => onPress(digit)}>
            <Stack>
                <Typography level="title-lg">{digit}</Typography>
                    { letters ?
                        <Typography level="body-xs">{letters}</Typography> :
                        <Box sx={{ height: "14pt" }} /> }
            </Stack>
        </Button>
    );

}


export default function PhoneDialpad({onPress}: PhoneDialpadType) {
    const spacing = 0.3;
    return (
        <Stack spacing={spacing}>
            <Stack direction="row" spacing={spacing}>
                <PhoneButton digit={"1"} letters={""} onPress={onPress} />
                <PhoneButton digit={"2"} letters={"ABC"} onPress={onPress} />
                <PhoneButton digit={"3"} letters={"DEF"} onPress={onPress} />
            </Stack>
            <Stack direction="row" spacing={spacing}>
                <PhoneButton digit={"4"} letters={"GHI"} onPress={onPress} />
                <PhoneButton digit={"5"} letters={"JKL"} onPress={onPress} />
                <PhoneButton digit={"6"} letters={"MNO"} onPress={onPress} />
            </Stack>
            <Stack direction="row" spacing={spacing}>
                <PhoneButton digit={"7"} letters={"PQRS"} onPress={onPress} />
                <PhoneButton digit={"8"} letters={"TUV"} onPress={onPress} />
                <PhoneButton digit={"9"} letters={"WXYZ"} onPress={onPress} />
            </Stack>
            <Stack direction="row" spacing={spacing}>
                <PhoneButton digit={"*"} letters={""} onPress={onPress} />
                <PhoneButton digit={"0"} letters={""} onPress={onPress} />
                <PhoneButton digit={"#"} letters={""} onPress={onPress} />
            </Stack>
        </Stack>
    );

}
